__turbopack_context__.v({
  "button": "AVideo-module__WSqXla__button",
  "image": "AVideo-module__WSqXla__image",
  "image-is-background": "AVideo-module__WSqXla__image-is-background",
  "playback-control": "AVideo-module__WSqXla__playback-control",
  "video": "AVideo-module__WSqXla__video",
  "video-is-background": "AVideo-module__WSqXla__video-is-background",
  "video-is-visible": "AVideo-module__WSqXla__video-is-visible",
  "with-playback-control": "AVideo-module__WSqXla__with-playback-control",
});
